var React = require('react');

function SeasongroupIconsSocmedFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.3 9H4.9v9H1.5V9H-.1V5.8h1.6v-2C1.5 2.3 2.1 0 5 0h2.6v3.1H5.7c-.3 0-.8.2-.8.9v1.9h2.6L7.3 9z","style":{"fillRule":"evenodd","clipRule":"evenodd"},"transform":"translate(.143)"}));
}

SeasongroupIconsSocmedFacebook.defaultProps = {"viewBox":"0 0 7.7 18","style":{"enableBackground":"new 0 0 7.7 18"},"xmlSpace":"preserve"};

module.exports = SeasongroupIconsSocmedFacebook;

SeasongroupIconsSocmedFacebook.default = SeasongroupIconsSocmedFacebook;
